// @ts-check
import classNames from 'classnames';
import React from 'react';

import './MiniSpinner.scss';

/** @type {import('~/types/React').ReactFC} */
const MiniSpinner = ({ className }) => {
	const NUM_BARS = 12;
	const [step, setStep] = React.useState(0);

	// Update the step to make a classic loader. Clear timeout on unmount.
	React.useEffect(() => {
		const cb = setTimeout(() => {
			setStep((s) => s + 1);
		}, 150);

		return () => clearTimeout(cb);
	}, [step]);

	// Make a consistent map that we can choose indices from.
	const OpacityMap = Array(NUM_BARS)
		.fill(null)
		.map((_, i) => Math.min(1, (1 * (NUM_BARS - i + 1)) / 12));

	return (
		<svg className={classNames('mini-spinner', className)} x={16} y={16} viewBox={[0, 0, 16, 16].join(' ')}>
			<g id="bars" strokeLinecap="round">
				{new Array(NUM_BARS).fill(null).map((_, i) => (
					<path
						key={i}
						className="bar"
						transform={`rotate(-${(360 / NUM_BARS) * i})`}
						stroke="currentColor"
						strokeWidth={1}
						strokeOpacity={OpacityMap[(i + step) % NUM_BARS]}
						d="M 8 4.5 v -2"
					/>
				))}
			</g>
		</svg>
	);
};

export default MiniSpinner;
